export default __webpack_public_path__ + "static/thumbnail-OSC_Right_to_Work_poster-3f0c7178eba1ac58e229b510b7ef39da.png";